import { $themeConfig } from '../theme.config';

export const initialState = {
    isDarkMode: false,
    mainLayout: 'app',
    theme: 'light',
    menu: $themeConfig.menu,
    layout: 'full',
    rtlClass: 'ltr',
    animation: '',
    navbar: 'navbar-sticky',
    locale: 'en',
    sidebar: false,
    languageList: [
        { code: 'zh', name: 'Chinese' },
        { code: 'da', name: 'Danish' },
        { code: 'en', name: 'English' },
        { code: 'fr', name: 'French' },
        { code: 'de', name: 'German' },
        { code: 'el', name: 'Greek' },
        { code: 'hu', name: 'Hungarian' },
        { code: 'it', name: 'Italian' },
        { code: 'ja', name: 'Japanese' },
        { code: 'pl', name: 'Polish' },
        { code: 'pt', name: 'Portuguese' },
        { code: 'ru', name: 'Russian' },
        { code: 'es', name: 'Spanish' },
        { code: 'sv', name: 'Swedish' },
        { code: 'tr', name: 'Turkish' },
        { code: 'ae', name: 'Arabic' },
    ],
    isShowMainLoader: true,
    semidark: false,
};

type AppState = typeof initialState;

function resolveDarkMode(state: AppState, theme: string): boolean {
    if (theme === 'light') {
        return false;
    }
    if (theme === 'dark') {
        return true;
    }
    if (theme === 'system') {
        return globalThis.matchMedia?.('(prefers-color-scheme: dark)')?.matches ?? false;
    }
    return state.isDarkMode || false;
}

function applyDarkModeClass(isDarkMode: boolean): void {
    const body = document.querySelector('body');
    if (isDarkMode) {
        body?.classList.add('dark');
    } else {
        body?.classList.remove('dark');
    }
}

function handleToggleTheme(state: AppState, rawPayload: string): AppState {
    const payload = rawPayload || state.theme;
    localStorage.setItem('theme', payload);
    const isDarkMode = resolveDarkMode(state, payload);
    applyDarkModeClass(isDarkMode);
    return { ...state, theme: payload, isDarkMode };
}

function handleToggleAnimation(state: AppState, rawPayload: string): AppState {
    const payload = rawPayload?.trim();
    localStorage.setItem('animation', payload);
    if (payload) {
        const eleanimation = document.querySelector('.animation');
        eleanimation?.classList.add('animate__animated', payload);
    }
    return { ...state, animation: payload };
}

export function indexReducer(state = initialState, action: any) {
    const type = action.type;
    let payload = action.payload;

    switch (type) {
        case 'toggleDirection':
            localStorage.setItem('direction', payload);
            document.querySelector('html')?.setAttribute('dir', payload || 'ltr');
            return { ...state, direction: payload };
        case 'toggleMainLoader':
            return { ...state, isShowMainLoader: payload };
        case 'setMainLayout':
            return { ...state, mainLayout: payload };
        case 'toggleTheme':
            return handleToggleTheme(state, payload);
        case 'toggleMenu':
            payload = payload || state.menu;
            localStorage.setItem('menu', payload);
            return { ...state, sidebar: false, menu: payload };
        case 'toggleLayout':
            payload = payload || state.layout;
            localStorage.setItem('layout', payload);
            return { ...state, layout: payload };
        case 'toggleRTL':
            payload = payload || state.rtlClass;
            localStorage.setItem('rtlClass', payload);
            document.querySelector('html')?.setAttribute('dir', payload || 'ltr');
            return { ...state, rtlClass: payload };
        case 'toggleAnimation':
            return handleToggleAnimation(state, payload);
        case 'toggleNavbar':
            payload = payload || state.navbar;
            localStorage.setItem('navbar', payload);
            return { ...state, navbar: payload };
        case 'toggleSemidark':
            payload = payload || false;
            localStorage.setItem('semidark', payload);
            return { ...state, semidark: payload };
        case 'toggleLocale':
            payload = payload || state.locale;
            localStorage.setItem('i18n_locale', payload);
            return { ...state, locale: payload };
        case 'toggleSidebar':
            return { ...state, sidebar: !state.sidebar };
        default:
            return state;
    }
}
